export default {
  items: [
    {
      name: 'Home',
      url: '/home',
      icon: 'icon-speedometer',
    },{
      name: 'Contact Details',
      url: '/contact-details',
      icon: 'icon-phone',
    },{
      name: 'Change Password',
      url: '/change-password',
      icon: 'icon-key',
    },

    // {
    //   name: 'Download CoreUI',
    //   url: 'https://coreui.io/react/',
    //   icon: 'icon-cloud-download',
    //   class: 'mt-auto',
    //   variant: 'success',
    //   attributes: { target: '_blank', rel: "noopener" },
    // },
    // {
    //   name: 'Try CoreUI PRO',
    //   url: 'https://coreui.io/pro/react/',
    //   icon: 'icon-layers',
    //   variant: 'danger',
    //   attributes: { target: '_blank', rel: "noopener" },
    // },
  ],
};
